import { render, staticRenderFns } from "./companyBoxPrint.vue?vue&type=template&id=5154d260&"
import script from "./companyBoxPrint.vue?vue&type=script&lang=ts&"
export * from "./companyBoxPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports